import { render, staticRenderFns } from "./tablePten.vue?vue&type=template&id=7202330c&scoped=true"
import script from "./tablePten.vue?vue&type=script&lang=js"
export * from "./tablePten.vue?vue&type=script&lang=js"
import style0 from "./tablePten.vue?vue&type=style&index=0&id=7202330c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202330c",
  null
  
)

export default component.exports